





















































































































import { Component, Vue, Model, Emit } from "vue-property-decorator";
import SearchPaginationTable from "@/components/search-pagination-table.vue";
import DialogTable from "@/components/dialog-table.vue";
import moment from "moment";
import { post, get } from "@/unite/api";
import Dialog from "@/components/dialog.vue";
@Component({
  components: { SearchPaginationTable, Dialog, DialogTable },
})
export default class LargeOrderList extends Vue {
  visible: boolean = false;
  loading: boolean = false;
  merchantList: object[] = [];
  openState: Number[] = [0, 0, 0, 0];
  optionTitle: string = "";
  modifyForm: any;
  rules: object = {
    rate_type: [
      {
        required: true,
        message: "请输入选择费率类型",
        trigger: "blur",
      },
    ],
    client_ip: [
      {
        required: true,
        message: "请输入白名单ip",
        trigger: "blur",
      },
    ],
  };
  activeName: any;
  current: number = 1;
  pageSizeArr: any[] = [10, 20, 40, 100];
  pageSize: any = 10;
  projectReviewList: object[] = [];
  countData: number = 0;
  info: object = {
    name: "",
    open_state: 0,
    page_no: 1,
    page_size: 10,
  };
  dialogData: any = {
    optionTitle: "开通服务",
    modifyForm: {
      url: "/api/reviewMerchantProject",
      width: "700px",
      form: {
        id: 0,
        open_state: 3,
        rate_type: 2,
        client_ip: "",
        rate: 0,
        is_share_balance: true,
      },
      showData: [],
      formLabelWidth: "100px",
      data: [
        {
          type: "input",
          model: "id",
          name: "ID",
          disabled: true,
        },
        {
          type: "number",
          model: "rate",
          name: "费率",
        },
        {
          type: "select",
          model: "rate_type",
          name: "费率类型",
        },
        {
          type: "switch",
          model: "enable",
          name: "是否开启",
        },
        {
          type: "switch",
          model: "is_share_balance",
          name: "是否共享余额",
        },
        {
          type: "input",
          model: "client_ip",
          name: "白名单ip",
        },
      ],
      select: {
        rate_type: [
          { value: 1, label: "浮动费率" },
          { value: 2, label: "固定费率" },
        ],
      },
    },
    rules: {
      rate_type: [
        {
          required: true,
          message: "请输入选择费率类型",
          trigger: "blur",
        },
      ],
      client_ip: [
        {
          required: true,
          message: "请输入白名单ip",
          trigger: "blur",
        },
      ],
    },
  };
  mounted() {
    this.getMerchantList();
    this.getProjectReviewList();
  }
  created() {
    // console.log(this.api.get('/api/apply/list', this.pageData.info))
  }
  private btnClick(methods: string) {
    if (methods === "add") {
      // @ts-ignore
      this.$refs.table.loading = true;
      post("/api/getMerchantList", { Name: "", page_size: 100000, page_no: 1 })
        .then((d) => {
          // @ts-ignore
          this.$refs.table.loading = false;
          this.dialogData.modifyForm.select.parent_id = [
            { value: -999, label: "" },
          ];
          //@ts-ignore
          d.data.Data.forEach((item) => {
            this.dialogData.modifyForm.select.parent_id = [
              ...this.dialogData.modifyForm.select.parent_id,
              { value: item.id, label: item.name },
            ];
          });
        })
        .catch((e) => {
          // @ts-ignore
          this.$refs.table.loading = false;
        });
    }
  }
  handleClick(methods: string, row: any) {
    if (methods === "updata") {
    }
  }
  // 刷新列表
  refesh(bool: boolean) {
    if (bool) {
      this.getProjectReviewList();
    }
    this.visible = false;
  }
  // 获取全部商户列表
  getMerchantList() {
    this.loading = true;
    post("/api/getMerchantList", { Name: "", page_size: 100000, page_no: 1 })
      .then((d) => {
        this.loading = false;
        this.countData = d.data.count_data;
        //@ts-ignore
        d.data.Data.forEach((item) => {
          this.merchantList = [
            ...this.merchantList,
            { value: item.name, label: item.name },
          ];
        });
      })
      .catch((e) => {
        this.loading = false;
      });
  }
  handleTabClick(obj: any) {
    // @ts-ignore
    this.info["open_state"] = Number(obj.index);
    this.getProjectReviewList();
  }
  // 搜索
  // search() {
    // post('/api/getProjectByMerchant', { id: this.id }).then(d => {
    //   this.openState = [0, 0, 0, 0];
    //   // @ts-ignore
    //   d.data.forEach(item => {
    //     // @ts-ignore
    //     this.openState[item['open_state']] += 1;
    //   });
    //   console.log(this.openState);
    // });
  // }
 private search() {
   this.handleCurrentChange(1)
  }
  // 获取商户申请项目列表
  private getProjectReviewList() {
    post("/api/getProjectReviewList", this.info).then((d) => {
      this.projectReviewList = d.data.Data;
      this.countData = d.data.count_data;
    });
  }
  private handleSizeChange(val: number) {
    this.pageSize = val;
    // @ts-ignore
    this.info.page_size = val;
    this.getProjectReviewList();
  }
  private handleCurrentChange(val: number) {
    this.current = val;
    // @ts-ignore
    this.info.page_no = val;
    this.getProjectReviewList();
  }
  private publicfuction(info: any, msg: string, row: any) {
    switch (msg) {
      case "开通":
        this.optionTitle = "开通服务";
        this.dialogData.modifyForm.url = "/api/reviewMerchantProject";
        this.dialogData.modifyForm.form.id = info.id;
        this.dialogData.modifyForm.form.rate = row.rate * 1;
        this.dialogData.modifyForm.form.client_ip = row.client_ip;
        this.dialogData.modifyForm.form.open_state = info.open_state;
        this.dialogData.modifyForm.form.enable = row.enable;
        this.dialogData.modifyForm.form.is_share_balance = row.is_share_balance;
        this.modifyForm = this.dialogData.modifyForm;
        this.visible = true;
        break;
      case "修改":
        this.optionTitle = "修改服务";
        this.dialogData.modifyForm.url = "/api/updateMerchantProject";
        this.dialogData.modifyForm.form.id = info.id;
        this.dialogData.modifyForm.form.rate = row.rate * 1;
        this.dialogData.modifyForm.form.client_ip = row.client_ip;
        this.dialogData.modifyForm.form.open_state = info.open_state;
        this.dialogData.modifyForm.form.rate_type = row.rate_type;
        this.dialogData.modifyForm.form.enable = row.enable;
        this.dialogData.modifyForm.form.is_share_balance = row.is_share_balance;
        this.modifyForm = this.dialogData.modifyForm;

        this.visible = true;
        break;
      case "驳回":
        this.$confirm(
          `此操作将${msg}选中数据（id=${info.id}）, 是否继续?`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            post("/api/reviewMerchantProject", info)
              .then((d) => {
                this.$message({
                  type: "success",
                  message: `${msg}成功!`,
                });
                this.getProjectReviewList();
              })
              .catch((e) => {});
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: `已取消${msg}`,
            });
          });
    }
  }
}
